// This feature's copy lives together so all hour-entry views use the same
// monthly declaration and can fall back safely for an unsupported locale.
const copy = {
  en: {
    question: 'Have you been on vacation this month?',
    hint: 'Tick if you took vacation during this month. This answer is shared with payroll; it does not change your reported hours.',
    saving: 'Saving…', saved: 'Saved', loading: 'Loading…', unreported: 'No vacation answer reported for this month yet.',
    loadError: 'Could not load your vacation answer.', saveError: 'Could not save your vacation answer. Please try again.', retry: 'Retry',
  },
  da: {
    question: 'Har du holdt ferie denne måned?',
    hint: 'Sæt kryds, hvis du har holdt ferie i denne måned. Svaret vises i lønbehandlingen og ændrer ikke dine indberettede timer.',
    saving: 'Gemmer…', saved: 'Gemt', loading: 'Indlæser…', unreported: 'Der er endnu ikke indberettet et feriesvar for denne måned.',
    loadError: 'Kunne ikke hente dit feriesvar.', saveError: 'Kunne ikke gemme dit feriesvar. Prøv igen.', retry: 'Prøv igen',
  },
  hu: {
    question: 'Volt szabadságon ebben a hónapban?',
    hint: 'Jelölje be, ha ebben a hónapban szabadságon volt. A válasz a bérszámfejtésnél látható, és nem módosítja a megadott munkaórákat.',
    saving: 'Mentés…', saved: 'Mentve', loading: 'Betöltés…', unreported: 'Erre a hónapra még nem adott választ a szabadságról.',
    loadError: 'A szabadságra adott válasz nem tölthető be.', saveError: 'A válasz mentése nem sikerült. Próbálja újra.', retry: 'Újra',
  },
  de: {
    question: 'Haben Sie diesen Monat Urlaub genommen?',
    hint: 'Ankreuzen, wenn Sie diesen Monat Urlaub genommen haben. Die Antwort wird der Lohnabrechnung angezeigt und ändert Ihre erfassten Stunden nicht.',
    saving: 'Speichern…', saved: 'Gespeichert', loading: 'Laden…', unreported: 'Für diesen Monat liegt noch keine Urlaubsangabe vor.',
    loadError: 'Ihre Urlaubsangabe konnte nicht geladen werden.', saveError: 'Ihre Urlaubsangabe konnte nicht gespeichert werden. Bitte erneut versuchen.', retry: 'Erneut versuchen',
  },
  pl: {
    question: 'Czy w tym miesiącu byłeś/byłaś na urlopie?',
    hint: 'Zaznacz, jeśli w tym miesiącu korzystałeś/korzystałaś z urlopu. Odpowiedź jest widoczna dla działu płac i nie zmienia zgłoszonych godzin.',
    saving: 'Zapisywanie…', saved: 'Zapisano', loading: 'Ładowanie…', unreported: 'Nie zgłoszono jeszcze odpowiedzi o urlopie w tym miesiącu.',
    loadError: 'Nie udało się wczytać informacji o urlopie.', saveError: 'Nie udało się zapisać informacji o urlopie. Spróbuj ponownie.', retry: 'Spróbuj ponownie',
  },
  ro: {
    question: 'Ați fost în concediu în această lună?',
    hint: 'Bifați dacă ați fost în concediu în această lună. Răspunsul este vizibil la salarizare și nu modifică orele raportate.',
    saving: 'Se salvează…', saved: 'Salvat', loading: 'Se încarcă…', unreported: 'Nu există încă un răspuns despre concediu pentru această lună.',
    loadError: 'Răspunsul despre concediu nu a putut fi încărcat.', saveError: 'Răspunsul nu a putut fi salvat. Încercați din nou.', retry: 'Reîncercați',
  },
  bg: {
    question: 'Бяхте ли в отпуск този месец?',
    hint: 'Отбележете, ако сте били в отпуск този месец. Отговорът е видим за изчисляването на заплатата и не променя отчетените часове.',
    saving: 'Запазване…', saved: 'Запазено', loading: 'Зареждане…', unreported: 'Все още няма отговор за отпуск през този месец.',
    loadError: 'Отговорът за отпуска не може да бъде зареден.', saveError: 'Отговорът не може да бъде запазен. Опитайте отново.', retry: 'Опитайте отново',
  },
  cs: {
    question: 'Čerpali jste tento měsíc dovolenou?',
    hint: 'Zaškrtněte, pokud jste tento měsíc čerpali dovolenou. Odpověď uvidí mzdová účtárna a nezmění vykázané hodiny.',
    saving: 'Ukládání…', saved: 'Uloženo', loading: 'Načítání…', unreported: 'Údaj o dovolené za tento měsíc zatím nebyl nahlášen.',
    loadError: 'Údaj o dovolené se nepodařilo načíst.', saveError: 'Údaj se nepodařilo uložit. Zkuste to znovu.', retry: 'Zkusit znovu',
  },
  sk: {
    question: 'Čerpali ste tento mesiac dovolenku?',
    hint: 'Zaškrtnite, ak ste tento mesiac čerpali dovolenku. Odpoveď uvidí mzdová účtáreň a nezmení vykázané hodiny.',
    saving: 'Ukladanie…', saved: 'Uložené', loading: 'Načítavanie…', unreported: 'Údaj o dovolenke za tento mesiac zatiaľ nebol nahlásený.',
    loadError: 'Údaj o dovolenke sa nepodarilo načítať.', saveError: 'Údaj sa nepodarilo uložiť. Skúste to znova.', retry: 'Skúsiť znova',
  },
  hr: {
    question: 'Jeste li ovaj mjesec bili na godišnjem odmoru?',
    hint: 'Označite ako ste ovaj mjesec bili na godišnjem odmoru. Odgovor je vidljiv pri obračunu plaće i ne mijenja prijavljene sate.',
    saving: 'Spremanje…', saved: 'Spremljeno', loading: 'Učitavanje…', unreported: 'Za ovaj mjesec još nije prijavljen odgovor o godišnjem odmoru.',
    loadError: 'Odgovor o godišnjem odmoru nije moguće učitati.', saveError: 'Odgovor nije moguće spremiti. Pokušajte ponovno.', retry: 'Pokušajte ponovno',
  },
  sr: {
    question: 'Da li ste ovog meseca bili na godišnjem odmoru?',
    hint: 'Označite ako ste ovog meseca bili na godišnjem odmoru. Odgovor je vidljiv pri obračunu zarade i ne menja prijavljene sate.',
    saving: 'Čuvanje…', saved: 'Sačuvano', loading: 'Učitavanje…', unreported: 'Za ovaj mesec još nije prijavljen odgovor o godišnjem odmoru.',
    loadError: 'Odgovor o godišnjem odmoru nije moguće učitati.', saveError: 'Odgovor nije moguće sačuvati. Pokušajte ponovo.', retry: 'Pokušajte ponovo',
  },
};

export const monthlyVacationCopy = (language) => copy[String(language || 'en').split('-')[0]] || copy.en;
